import { AxiosError } from 'axios'

export const getApiErrorMessage = (e: AxiosError<any>) => e.response?.data?.error?.message
